export default __webpack_public_path__ + "static/media/PAFI_Audit Report 2024.855c450f.pdf";